import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//MUI
import { Button, ButtonGroup } from "@mui/material";

//Actions
import { setFeedType } from "../../actions/feed";

const FeedTypeSelector = ({ currentFeedType, feedTypeLoading, setFeedType }) => {
  const handleFeedTypeChange = (feedType) => {
    setFeedType(feedType);
  };

  return (
    <div className="w-full pt-1 md:pb-2 md:pt-0">
      <ButtonGroup
        variant="outlined"
        aria-label="feed type selector"
        className="w-full bg-background shadow-sm md:border md:border-separator overflow-hidden"
        sx={{
          borderRadius: 0,
          "@media (min-width: 768px)": {
            borderRadius: "8px",
          },
          "& .MuiButton-root": {
            borderColor: "transparent",
            flex: 1, // Make buttons equal width
            "&:hover": {
              borderColor: "transparent",
            },
          },
        }}
      >
        <Button
          onClick={() => handleFeedTypeChange("trending")}
          disabled={feedTypeLoading}
          className={`py-4 px-4 text-sm rounded-none md:rounded-lg font-medium transition-all duration-200 relative ${
            currentFeedType === "trending" ? "text-primaryText" : "text-secondaryText"
          } ${feedTypeLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          disableRipple
          sx={{
            textTransform: "none",
            borderRadius: 0,
            backgroundColor: "white",
            justifyContent: "center",
            "@media (min-width: 768px)": {
              borderRadius: "8px",
            },
            "&:hover": {
              backgroundColor: currentFeedType === "trending" ? "white" : "#f9fafb",
            },
            "&:disabled": {
              opacity: 0.5,
              cursor: "not-allowed",
            },
            "&::before":
              currentFeedType === "trending"
                ? {
                    content: '""',
                    position: "absolute",
                    top: "-1px",
                    left: "0px",
                    right: "-1px",
                    height: "4px",
                    backgroundColor: "#10b981",
                  }
                : {},
          }}
        >
          Trending
        </Button>
        <Button
          onClick={() => handleFeedTypeChange("following")}
          disabled={feedTypeLoading}
          className={`py-4 px-4 text-sm rounded-none md:rounded-lg font-medium transition-all duration-200 relative ${
            currentFeedType === "following" ? "text-primaryText" : "text-secondaryText"
          } ${feedTypeLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          disableRipple
          sx={{
            textTransform: "none",
            borderRadius: 0,
            backgroundColor: "white",
            justifyContent: "center",
            "@media (min-width: 768px)": {
              borderRadius: "8px",
            },
            "&:hover": {
              backgroundColor: currentFeedType === "following" ? "white" : "#f9fafb",
            },
            "&:disabled": {
              opacity: 0.5,
              cursor: "not-allowed",
            },
            "&::before":
              currentFeedType === "following"
                ? {
                    content: '""',
                    position: "absolute",
                    top: "-1px",
                    left: "-1px",
                    right: "0px",
                    height: "4px",
                    backgroundColor: "#10b981",
                  }
                : {},
          }}
        >
          Following
        </Button>
      </ButtonGroup>
    </div>
  );
};

FeedTypeSelector.propTypes = {
  currentFeedType: PropTypes.string.isRequired,
  feedTypeLoading: PropTypes.bool.isRequired,
  setFeedType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  currentFeedType: state.feed.feeds?.currentFeedType || "trending",
  feedTypeLoading: state.feed.feeds?.feedTypeLoading ?? true,
});

export default connect(mapStateToProps, { setFeedType })(FeedTypeSelector);
